export const regions = [
  { label: 'North America', value: 'north_america' },
  { label: 'Europe', value: 'europe' },
  { label: 'Asia', value: 'asia' },
  { label: 'South America', value: 'south_america' },
  { label: 'Africa', value: 'africa' },
  { label: 'Oceania', value: 'oceania' },
  { label: 'Central America', value: 'central_america' },
  { label: 'Middle East', value: 'middle_east' },
  { label: 'Caribbean', value: 'caribbean' },
  { label: 'Antarctica', value: 'antarctica' },
];
export const customerStatus = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Suspended', value: 'suspended' },
  { label: 'Pending', value: 'pending' },
  { label: 'Cancelled', value: 'cancelled' },
];
export const customerSources = [
  { label: 'Website', value: 'website' },
  { label: 'Referral', value: 'referral' },
  { label: 'Social Media', value: 'social_media' },
  { label: 'Email Campaign', value: 'email_campaign' },
  { label: 'In-Store', value: 'in_store' },
  { label: 'Phone Inquiry', value: 'phone_inquiry' },
];
